import { useKeycloak } from '@react-keycloak/web';
import { UserIdentity } from 'react-admin';

import { AllowedUserTypes } from './userTypes';

declare let location: any;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useAuthProvider = (_clientID: string) => {
  const { keycloak, initialized } = useKeycloak();
  return {
    checkAuth: async (): Promise<void> => {
      if (!keycloak?.authenticated || !initialized) {
        return Promise.reject();
      }
      return Promise.resolve();
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    checkError: (_error: Error): Promise<void> => {
      return keycloak.authenticated && keycloak.token
        ? Promise.resolve()
        : Promise.reject(Error('Failed to obtain access token.'));
    },
    getPermissions: (): Promise<boolean> => {
      if (keycloak?.authenticated && keycloak.token) {
        const { groups }: { groups: string[] } = keycloak.idTokenParsed as any;
        if (
          groups.some(g =>
            Object.values(AllowedUserTypes).includes(
              g.toUpperCase() as AllowedUserTypes,
            ),
          )
        ) {
          return Promise.resolve(true);
        }
      }
      return Promise.resolve(false);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    login: (_payload: any): Promise<void> => {
      return keycloak.login();
    },
    getIdentity: (): Promise<UserIdentity> => {
      try {
        if (!keycloak || !keycloak.authenticated) {
          return Promise.reject();
        }
        return Promise.resolve({
          id: `${keycloak.subject}`,
          fullName: (keycloak.idTokenParsed as any)?.['name'] || '',
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    logout: (): Promise<void> => {
      if (keycloak?.authenticated) {
        // keycloak-js 15 logs out with `redirect_uri`, which Keycloak 18+
        // rejects. Build the logout URL with `post_logout_redirect_uri`;
        // Keycloak 16 and 21 both accept it.
        const params = new URLSearchParams({
          post_logout_redirect_uri: location.href.replace(
            location.hash,
            '#/login',
          ),
          client_id: keycloak.clientId || '',
        });
        if (keycloak.idToken) params.set('id_token_hint', keycloak.idToken);
        const authServerUrl = (keycloak.authServerUrl || '').replace(/\/$/, '');
        const realm = encodeURIComponent(keycloak.realm || '');
        location.replace(
          `${authServerUrl}/realms/${realm}/protocol/openid-connect/logout?${params}`,
        );
        // Like keycloak.logout(): never resolves, the page navigates away.
        return new Promise<void>(() => undefined);
      }
      return Promise.resolve();
    },
    keycloak,
  };
};
